import { FC, useEffect, useMemo, useState } from 'react';

import { IColumnDescriptor } from '../table/types';
import GenericTable from '../table';

import { useAppSelector } from '../../hooks/redux';
import { IWalletTransaction, WalletTransactionType } from '../../store/wallet.slice';

export interface IOperationRow {
  date: string;
  accrued?: number; // Опционально, так как может быть пустым
  debited?: number; // Опционально, так как может быть пустым
  description: string;
}
const formatNumber = (val?: number) => new Intl.NumberFormat('ru-RU').format(val ? val : 0);

const columns: IColumnDescriptor<IOperationRow>[] = [
  {
    header: 'Дата',
    key: 'date',
    align: 'center',
  },
  {
    header: 'Начислено Бр',
    key: 'accrued',
    align: 'center',
    // Специальный рендеринг для отображения пустоты, если значение не определено
    render: (row) => formatNumber(row.accrued),
  },
  {
    header: 'Списано Бр',
    key: 'debited',
    align: 'center',
    // Специальный рендеринг для отображения пустоты, если значение не определено
    render: (row) => formatNumber(row.debited),
  },
  {
    header: 'История операций',
    key: 'description',
    align: 'center',
    width: '50%',
  },
];

const convertToOperationRow = (transactions: IWalletTransaction[]) => {
  return transactions.map((t) => {
    return {
      date: new Date(t.operation_date).toLocaleDateString(),
      accrued:
        t.type === WalletTransactionType.CREDIT || t.type === WalletTransactionType.RESERVE_ROLLBACK
          ? t.amount
          : undefined,
      debited:
        t.type === WalletTransactionType.DEBIT || t.type === WalletTransactionType.RESERVE ? t.amount : undefined,
      description: t.description,
    } as IOperationRow;
  });
};

export const BonusesHistory: FC = () => {
  const [isShortMode, setIsShortMode] = useState(true);
  const wallet = useAppSelector((s) => s.walletSlice);

  const [walletTransactions, setWalletTransactions] = useState<IOperationRow[]>([]);

  useEffect(() => {
    setWalletTransactions(convertToOperationRow(wallet.transactions));
  }, [wallet.transactions]);

  const data = useMemo(() => {
    if (isShortMode) {
      return [...walletTransactions].splice(0, 5);
    }

    return walletTransactions;
  }, [isShortMode, walletTransactions]);

  return (
    <div className="flex flex-col gap-1 w-full">
      <p className="font-comfortaa text-[20px] font-medium">История бонусных рублей</p>
      {walletTransactions.length <= 0 && (
        <p className="font-manrope text-[16px] text-gray-600">Пока у вас не было операций с бонусными рублями.</p>
      )}
      {walletTransactions.length > 0 && walletTransactions && <GenericTable columns={columns} data={data} />}
      {walletTransactions.length > 5 && (
        <button className="text-sm hover:underline mb-2 cursor-pointer" onClick={() => setIsShortMode((v) => !v)}>
          {isShortMode && 'раскрыть подробнее'}
          {!isShortMode && 'скрыть подробнее'}
        </button>
      )}
    </div>
  );
};
